/* eslint-disable prettier/prettier */
/* eslint-disable */

export const defaultDataTypeFormData = {
  section: undefined,
  kind: undefined,
  type: undefined
};
